import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story04.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story04'
const figure = articleFigure(dir)

export const story04: Article = {
  id: 4,
  slug: 'how-china-controls-gallium',
  order: 4,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('gallium'),
  author: 'Sam Geall',
  // Two pins, not a mine — the piece is the line between them; `region[0]` is the label.
  region: [
    {
      name: 'Beijing',
      country: 'China',
      coordinates: [116.4074, 39.9042],
      impact: 'geopolitical',
    },
    {
      name: 'Washington, DC',
      country: 'US',
      coordinates: [-77.0369, 38.9072],
      impact: 'geopolitical',
    },
  ],
  impactList: ['geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[1]] }, // China’s leverage
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[3]] }, // Stalemate
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[4]] }, // Next steps
    ],
  },
}
